/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {
  if ($('.items-slider .item').length > 0) {
    return $('.items-slider').slick({
      dots: false,
      infinite: false,
      autoplay: false,
      centerMode: false,
      slidesToShow: 6,
      slidesToScroll: 1,
      prevArrow: "<button type='button' class='slick-prev button icon-btn large fal fas-angle-left'></button>",
      nextArrow: "<button type='button' class='slick-next button icon-btn large fal fas-angle-right'></button>",
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 5,
            variableWidth: false,
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4,
            variableWidth: false,
          }
        },
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 3,
            variableWidth: false,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            variableWidth: false,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            variableWidth: false,
          }
        }
      ]
    });
  }
});